import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Button } from '../../../components/base';
import ContentTable from '../../../components/ContentTable/ContentTable.component';
import { PERSONAL_TEACHER_CONTRACT_TABLE_FIELDS } from '../../../constants/personnel.constant';

export default class TeacherContract extends PureComponent {
  constructor(props) {
    super(props);
    this.onClickAdd = this.onClickAdd.bind(this);
  }

  onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/personalia/surat/tambah-guru-kontrak');
  }

  render() {
    const { handleGetTeacherContract } = this.props;
    return (
      <div className="teacher-contract">
        <Button
          title="Tambah Surat Guru Kontrak"
          onClick={this.onClickAdd}
        />
        <div className="teacher-contract__content">
          <ContentTable
            onSearchContent={handleGetTeacherContract}
            tableFields={PERSONAL_TEACHER_CONTRACT_TABLE_FIELDS}
          />
        </div>
      </div>
    );
  }
}
TeacherContract.propTypes = {
  handleGetTeacherContract: PropTypes.func,
  history: PropTypes.object.isRequired,
};
TeacherContract.defaultProps = {
  handleGetTeacherContract: noop,
};
